module.exports = __webpack_public_path__ + "static/img/zx.90e3248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zx.png
// module id = d4MG
// module chunks = 1